<script lang="ts">
	import { getTranslate } from "../../utils/getTranslate.js";
	import translations from "./CareerCard.translations.json";
	import type { Position } from "../../../../core/schema/Position.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import accountant from "../../../../core/assets/icons/accountant.svg?raw";
	import technician from "../../../../core/assets/icons/technician.svg?raw";
	import developer from "../../../../core/assets/icons/developer.svg?raw";
	import sales from "../../../../core/assets/icons/sales.svg?raw";
	import socialmedia from "../../../../core/assets/icons/socialmedia.svg?raw";
	import arrowRightLong from "../../../../core/assets/icons/arrow-right-long.svg?raw";
	import { PositionIcon } from "../../../../core/schema/PositionIcon.js";
	import Icon from "../Icon.svelte";
	import Pill from "../Pill.svelte";
	import { getCareerDetailPath } from "../../../../core/schema/paths/getCareerDetailPath.js";
	import Link from "../Link.svelte";

	export let position: Position;

	const translate = getTranslate(translations);

	const positionIconMap: Record<PositionIcon, string> = {
		[PositionIcon.Technician]: technician,
		[PositionIcon.Developer]: developer,
		[PositionIcon.Sales]: sales,
		[PositionIcon.Accountant]: accountant,
		[PositionIcon.SocialMediaSpecialist]: socialmedia,
	};
</script>

<div class="flex flex-col justify-between gap-10 rounded-lg bg-gray-300 p-8">
	<div class="flex flex-col gap-10">
		<div class="flex flex-col gap-6">
			<Icon icon={positionIconMap[position.icon]} class="h-14 w-14" />
			<span class="text-2lg font-spaceGrotesk text-primary font-medium">{nbspify(position.name)}</span>
			<div class="flex flex-wrap gap-0.5">
				{#each position.labels as label}
					<Pill>
						{nbspify(label)}
					</Pill>
				{/each}
			</div>
		</div>

		<span class="text-xs">{nbspify(position.perex)}</span>
	</div>

	<Link href="/{getCareerDetailPath(position)}" variant="secondary" asButton icon={arrowRightLong}>
		{translate("detail")}
	</Link>
</div>
